import script from "./TabComportamentos.vue?vue&type=script&setup=true&lang=js"
export * from "./TabComportamentos.vue?vue&type=script&setup=true&lang=js"

import "./TabComportamentos.vue?vue&type=style&index=0&id=0f7393ca&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f7393ca"]])

export default __exports__